import React, { useMemo, useState } from 'react';
import OrderDetailsStepper from '../../../../../../components/OrderDetailsStepper/OrderDetailsStepper';
import TruckDetailsMap from '../../../../../../containers/Admin/OrderDetails/components/AdditionalDetails/TruckDetailsMap';
import BaseOrderDetails from '../../../../../../components/BaseOrderDetails/BaseOrderDetails';
import DeliverySchedule from '../../AdditionalDetails/DeliverySchedule';
import ClientDeliveryDetails from '../../AdditionalDetails/ClientDeliveryDetails';
import { ClientOrderProps } from '../../../clientOrder.interface';
import OrderContractDetails from '../../../../../../components/OrderContractDetails/OrderContractDetails';
import { cn } from '../../../../../../lib/utils';

const UnloadingStep: React.FC<ClientOrderProps> = (props) => {
	const { selectedOrder, contract, onBack, hideMap } = props;
	const [stepperMargin, setStepperMargin] = useState<number>(0);

	const isSimpleOrder = useMemo(() => {
		return selectedOrder?.trucks?.length === 1;
	}, [selectedOrder?.trucks]);

	const deliveryIncluded = useMemo(() => {
		return selectedOrder?.deliveryIncluded;
	}, [selectedOrder?.deliveryIncluded]);

	const handleWidthChange = (value: number) => {
		setStepperMargin(value);
	};

	const renderInitialSection = () => {
		return isSimpleOrder ? (
			<DeliverySchedule
				selectedOrder={selectedOrder}
				deliveryIncluded={deliveryIncluded!}
				simpleOrder={isSimpleOrder}
				step={4}
			/>
		) : !isSimpleOrder && !deliveryIncluded ? (
			<BaseOrderDetails
				selectedOrder={selectedOrder}
				isOpen={true}
				simpleOrder={isSimpleOrder}
				deliveryIncluded={deliveryIncluded!}
				target={selectedOrder?.target!}
				contract={contract}
			/>
		) : (
			<ClientDeliveryDetails
				selectedOrder={selectedOrder}
				simpleOrder={isSimpleOrder}
			/>
		);
	};

	return (
		<>
			<div
				style={{ marginBottom: `${stepperMargin}px` }}
				className={cn(onBack && 'mt-[96px]')}
			>
				<OrderDetailsStepper
					current={4}
					simpleOrder={isSimpleOrder}
					order={selectedOrder}
					onWidthChange={handleWidthChange}
				/>
			</div>

			{!hideMap ? (
				<div className="px-10 pt-7 pb-3.5">
					<TruckDetailsMap selectedOrder={selectedOrder} mode="toDelivery" />
				</div>
			) : null}

			<div className={`px-10 ${hideMap ? 'pt-7 pb-3.5' : 'py-3.5'}`}>
				{contract ? (
					<OrderContractDetails
						selectedOrder={selectedOrder}
						contract={contract}
						target="customer"
					/>
				) : (
					renderInitialSection()
				)}
			</div>

			{contract ? (
				<div className="px-10 py-3.5">{renderInitialSection()}</div>
			) : null}

			<div className="px-10 py-3.5">
				{!isSimpleOrder && !deliveryIncluded ? (
					<ClientDeliveryDetails
						selectedOrder={selectedOrder}
						simpleOrder={isSimpleOrder}
					/>
				) : (
					<BaseOrderDetails
						selectedOrder={selectedOrder}
						isOpen={true}
						simpleOrder={isSimpleOrder}
						deliveryIncluded={deliveryIncluded!}
						target={selectedOrder?.target!}
						contract={contract}
					/>
				)}
			</div>

			<div className="px-10 pb-7 pt-3.5">
				{isSimpleOrder ? (
					<ClientDeliveryDetails
						selectedOrder={selectedOrder}
						simpleOrder={isSimpleOrder}
					/>
				) : (
					<DeliverySchedule
						selectedOrder={selectedOrder}
						deliveryIncluded={deliveryIncluded!}
						simpleOrder={isSimpleOrder}
						step={4}
					/>
				)}
			</div>
		</>
	);
};

export default UnloadingStep;
